import React, { useCallback, useRef, useState, useMemo, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  Alert,
  Button,
  Icon,
  Input,
  PageHeading,
  Pills,
  Select,
  Table,
  Text,
} from 'barte-design-system';
import type { ColumnDefinition, PillsState } from 'barte-design-system';
import {
  CaretDown,
  CaretUp,
  Funnel,
  MagnifyingGlass,
} from '@phosphor-icons/react';
import { PortalPayfacsLayout } from '../PortalPayfacsLayout';
import './Transacoes.css';

// ─── Types ────────────────────────────────────────────────────────────────────

type TransacaoStatus = 'Aprovada' | 'Pendente' | 'Cancelada' | 'Estornada';
type MetodoPagamento = 'PIX' | 'Cartão de Crédito' | 'Cartão de Débito' | 'POS' | 'Boleto';

interface Transacao {
  id: string;
  cliente: string;
  sellerId: string;
  sellerNome: string;
  metodoPagamento: MetodoPagamento;
  dataPagamento: string;
  dataVencimento: string;
  valor: string;
  valorNumerico: number;
  status: TransacaoStatus;
}


const ALL_TRANSACOES: Transacao[] = [
  { id: 'TRX-001', cliente: 'Carlos Eduardo Mendes',   sellerId: 'SEL-001', sellerNome: 'Restaurante do João',   metodoPagamento: 'Cartão de Crédito', dataPagamento: '05/04/2026', dataVencimento: '05/04/2026', valor: 'R$ 187,50',   valorNumerico: 187.50,   status: 'Aprovada'   },
  { id: 'TRX-002', cliente: 'Fernanda Oliveira Lima',  sellerId: 'SEL-002', sellerNome: 'Loja da Maria Moda',    metodoPagamento: 'PIX',               dataPagamento: '04/04/2026', dataVencimento: '04/04/2026', valor: 'R$ 432,00',   valorNumerico: 432.00,   status: 'Aprovada'   },
  { id: 'TRX-003', cliente: 'Roberto Carvalho Silva',  sellerId: 'SEL-003', sellerNome: 'Auto Peças Central',    metodoPagamento: 'POS',               dataPagamento: '04/04/2026', dataVencimento: '04/04/2026', valor: 'R$ 85,90',    valorNumerico: 85.90,    status: 'Cancelada'  },
  { id: 'TRX-004', cliente: 'Juliana Santos Pereira',  sellerId: 'SEL-001', sellerNome: 'Restaurante do João',   metodoPagamento: 'PIX',               dataPagamento: '03/04/2026', dataVencimento: '03/04/2026', valor: 'R$ 64,00',    valorNumerico: 64.00,    status: 'Aprovada'   },
  { id: 'TRX-005', cliente: 'Marcos Antônio Rocha',    sellerId: 'SEL-004', sellerNome: 'Padaria Pão & Arte',    metodoPagamento: 'Cartão de Crédito', dataPagamento: '03/04/2026', dataVencimento: '10/05/2026', valor: 'R$ 1.250,00', valorNumerico: 1250.00,  status: 'Pendente'   },
  { id: 'TRX-006', cliente: 'Amanda Costa Ferreira',   sellerId: 'SEL-005', sellerNome: 'Farmácia Saúde Total',  metodoPagamento: 'Cartão de Débito',  dataPagamento: '02/04/2026', dataVencimento: '02/04/2026', valor: 'R$ 215,30',   valorNumerico: 215.30,   status: 'Aprovada'   },
  { id: 'TRX-007', cliente: 'Paulo Henrique Barros',   sellerId: 'SEL-006', sellerNome: 'Pet Shop Animal Love',  metodoPagamento: 'PIX',               dataPagamento: '02/04/2026', dataVencimento: '02/04/2026', valor: 'R$ 390,00',   valorNumerico: 390.00,   status: 'Aprovada'   },
  { id: 'TRX-008', cliente: 'Camila Rodrigues Neves',  sellerId: 'SEL-002', sellerNome: 'Loja da Maria Moda',    metodoPagamento: 'Cartão de Crédito', dataPagamento: '01/04/2026', dataVencimento: '01/05/2026', valor: 'R$ 8.400,00', valorNumerico: 8400.00,  status: 'Estornada'  },
  { id: 'TRX-009', cliente: 'Thiago Monteiro Castro',  sellerId: 'SEL-007', sellerNome: 'Ótica Visão Clara',     metodoPagamento: 'POS',               dataPagamento: '01/04/2026', dataVencimento: '01/05/2026', valor: 'R$ 2.780,00', valorNumerico: 2780.00,  status: 'Aprovada'   },
  { id: 'TRX-010', cliente: 'Letícia Alves Moreira',   sellerId: 'SEL-008', sellerNome: 'Hortifruti Verde Vida', metodoPagamento: 'PIX',               dataPagamento: '31/03/2026', dataVencimento: '31/03/2026', valor: 'R$ 47,80',    valorNumerico: 47.80,    status: 'Aprovada'   },
  { id: 'TRX-011', cliente: 'Bruno Figueiredo Lima',   sellerId: 'SEL-009', sellerNome: 'Academia FitLife',      metodoPagamento: 'Cartão de Crédito', dataPagamento: '30/03/2026', dataVencimento: '30/04/2026', valor: 'R$ 520,00',   valorNumerico: 520.00,   status: 'Pendente'   },
  { id: 'TRX-012', cliente: 'Priscila Gonçalves Luz',  sellerId: 'SEL-010', sellerNome: 'Barbearia Corte Certo', metodoPagamento: 'POS',               dataPagamento: '29/03/2026', dataVencimento: '29/03/2026', valor: 'R$ 75,00',    valorNumerico: 75.00,    status: 'Aprovada'   },
  { id: 'TRX-013', cliente: 'Diego Nascimento Porto',  sellerId: 'SEL-003', sellerNome: 'Auto Peças Central',    metodoPagamento: 'Boleto',            dataPagamento: '28/03/2026', dataVencimento: '05/04/2026', valor: 'R$ 3.190,00', valorNumerico: 3190.00,  status: 'Pendente'   },
  { id: 'TRX-014', cliente: 'Vanessa Melo Teixeira',   sellerId: 'SEL-005', sellerNome: 'Farmácia Saúde Total',  metodoPagamento: 'PIX',               dataPagamento: '28/03/2026', dataVencimento: '28/03/2026', valor: 'R$ 138,50',   valorNumerico: 138.50,   status: 'Aprovada'   },
  { id: 'TRX-015', cliente: 'Rafael Correia Bento',    sellerId: 'SEL-001', sellerNome: 'Restaurante do João',   metodoPagamento: 'Cartão de Débito',  dataPagamento: '27/03/2026', dataVencimento: '27/03/2026', valor: 'R$ 92,40',    valorNumerico: 92.40,    status: 'Cancelada'  },
];

// ─── Constants ────────────────────────────────────────────────────────────────

const STATUS_OPTIONS = [
  { value: 'Aprovada',  label: 'Aprovada'  },
  { value: 'Pendente',  label: 'Pendente'  },
  { value: 'Cancelada', label: 'Cancelada' },
  { value: 'Estornada', label: 'Estornada' },
];

const METODO_OPTIONS = [
  { value: 'Cartão de Crédito', label: 'Cartão de Crédito' },
  { value: 'Cartão de Débito',  label: 'Cartão de Débito'  },
  { value: 'PIX',               label: 'PIX'               },
  { value: 'POS',               label: 'POS'               },
  { value: 'Boleto',            label: 'Boleto'            },
];

const STATUS_PILL: Record<TransacaoStatus, PillsState> = {
  Aprovada:  'success',
  Pendente:  'warning',
  Cancelada: 'default',
  Estornada: 'error',
};

const METODO_PILLS_STATE: Record<MetodoPagamento, PillsState> = {
  'Cartão de Crédito': 'accent',
  'Cartão de Débito':  'info',
  'PIX':               'success',
  'POS':               'default',
  'Boleto':            'warning',
};

const PAGE_SIZE = 10;

// ─── Table columns ────────────────────────────────────────────────────────────

const COLUMNS: ColumnDefinition<Transacao>[] = [
  {
    key: 'cliente',
    title: 'Cliente',
    dataIndex: 'cliente',
    render: (value) => <Text variant="body-sm">{value as string}</Text>,
  },
  {
    key: 'metodoPagamento',
    title: 'Método de Pagamento',
    dataIndex: 'metodoPagamento',
    render: (value) => (
      <Pills
        label={value as string}
        state={METODO_PILLS_STATE[value as MetodoPagamento]}
        size="sm"
      />
    ),
  },
  {
    key: 'dataPagamento',
    title: 'Data de Pagamento',
    dataIndex: 'dataPagamento',
    render: (value) => <Text variant="body-sm">{value as string}</Text>,
  },
  {
    key: 'valor',
    title: 'Valor',
    dataIndex: 'valor',
    render: (value) => <Text variant="label-sm">{value as string}</Text>,
  },
  {
    key: 'status',
    title: 'Status',
    dataIndex: 'status',
    render: (value) => (
      <Pills
        label={value as string}
        state={STATUS_PILL[value as TransacaoStatus]}
        size="sm"
      />
    ),
  },
];

// ─── Search type options ──────────────────────────────────────────────────────

type SearchType = 'cliente' | 'seller' | 'id';

const SEARCH_TYPE_OPTIONS: { value: SearchType; label: string; placeholder: string }[] = [
  { value: 'cliente', label: 'Cliente',       placeholder: 'Buscar por cliente...'      },
  { value: 'seller',  label: 'Seller',        placeholder: 'Buscar por seller...'       },
  { value: 'id',      label: 'ID da compra',  placeholder: 'Buscar por ID da compra...' },
];

// ─── Component ────────────────────────────────────────────────────────────────

type SearchState = 'initial' | 'loading' | 'results' | 'empty' | 'error';

export function Transacoes() {
  const navigate = useNavigate();

  // Busca principal
  const [searchType, setSearchType] = useState<SearchType>('cliente');
  const [searchQuery, setSearchQuery] = useState('');
  const [typeDropdownOpen, setTypeDropdownOpen] = useState(false);
  const searchBarRef = useRef<HTMLDivElement>(null);

  // Filtros secundários
  const [statusFilter, setStatusFilter] = useState('');
  const [metodoPagamento, setMetodoPagamento] = useState('');
  const [dataPagamento, setDataPagamento] = useState('');
  const [dataVencimento, setDataVencimento] = useState('');
  const [valorCompra, setValorCompra] = useState('');

  // Estado da tela
  const [searchState, setSearchState] = useState<SearchState>('initial');
  const [transacoes, setTransacoes] = useState<Transacao[]>([]);
  const [currentPage, setCurrentPage] = useState(1);

  const filtroPanelRef = useRef<HTMLDivElement>(null);
  const [filtroPanelOpen, setFiltroPanelOpen] = useState(false);
  const [expandedFiltro, setExpandedFiltro] = useState<string | null>(null);

  const currentSearchType = SEARCH_TYPE_OPTIONS.find((o) => o.value === searchType)!;

  // Algum filtro preenchido?
  const algumFiltroPreenchido =
    searchQuery.trim() !== '' ||
    statusFilter !== '' ||
    metodoPagamento !== '' ||
    dataPagamento !== '' ||
    dataVencimento !== '' ||
    valorCompra.trim() !== '';

  // Fechar dropdowns ao clicar fora
  useEffect(() => {
    function handleClickOutside(e: MouseEvent) {
      if (searchBarRef.current && !searchBarRef.current.contains(e.target as Node)) {
        setTypeDropdownOpen(false);
      }
      if (filtroPanelRef.current && !filtroPanelRef.current.contains(e.target as Node)) {
        setFiltroPanelOpen(false);
      }
    }
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const filtrosAtivosCount = [statusFilter, metodoPagamento, dataPagamento, dataVencimento, valorCompra.trim()]
    .filter(Boolean).length;

  function toggleFiltroItem(key: string) {
    setExpandedFiltro((prev) => (prev === key ? null : key));
  }

  function handleAplicarFiltros() {
    setFiltroPanelOpen(false);
    if (algumFiltroPreenchido) handleBuscar();
  }

  function handleBuscar() {
    setSearchState('loading');
    setCurrentPage(1);

    setTimeout(() => {
      let resultado = [...ALL_TRANSACOES];
      const q = searchQuery.trim().toLowerCase();

      if (q) {
        if (searchType === 'cliente') {
          resultado = resultado.filter((t) => t.cliente.toLowerCase().includes(q));
        } else if (searchType === 'seller') {
          resultado = resultado.filter(
            (t) => t.sellerNome.toLowerCase().includes(q) || t.sellerId.toLowerCase().includes(q),
          );
        } else if (searchType === 'id') {
          resultado = resultado.filter((t) => t.id.toLowerCase().includes(q));
        }
      }

      if (statusFilter)    resultado = resultado.filter((t) => t.status === statusFilter);
      if (metodoPagamento) resultado = resultado.filter((t) => t.metodoPagamento === metodoPagamento);

      if (dataPagamento) {
        const [y, m, d] = dataPagamento.split('-');
        resultado = resultado.filter((t) => t.dataPagamento === `${d}/${m}/${y}`);
      }
      if (dataVencimento) {
        const [y, m, d] = dataVencimento.split('-');
        resultado = resultado.filter((t) => t.dataVencimento === `${d}/${m}/${y}`);
      }
      if (valorCompra.trim()) {
        const val = parseFloat(valorCompra.replace(',', '.'));
        if (!isNaN(val)) {
          resultado = resultado.filter(
            (t) => t.valorNumerico >= val * 0.95 && t.valorNumerico <= val * 1.05,
          );
        }
      }

      setTransacoes(resultado);
      setSearchState(resultado.length > 0 ? 'results' : 'empty');
    }, 600);
  }

  function handleLimparFiltros() {
    setSearchQuery('');
    setStatusFilter('');
    setMetodoPagamento('');
    setDataPagamento('');
    setDataVencimento('');
    setValorCompra('');
    setSearchState('initial');
    setTransacoes([]);
    setCurrentPage(1);
  }

  const pagedTransacoes = useMemo(() => {
    const start = (currentPage - 1) * PAGE_SIZE;
    return transacoes.slice(start, start + PAGE_SIZE);
  }, [transacoes, currentPage]);

  const totalPages = Math.ceil(transacoes.length / PAGE_SIZE);

  const handleKeyDown = useCallback(
    (e: React.KeyboardEvent) => {
      if (e.key === 'Enter' && algumFiltroPreenchido) handleBuscar();
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [algumFiltroPreenchido, searchQuery, searchType, statusFilter, metodoPagamento, dataPagamento, dataVencimento, valorCompra],
  );

  return (
    <PortalPayfacsLayout activeItem="transacoes">
      <main className="content">
        <div className="content-inner">
            <PageHeading title="Transações" />

            {/* Barra de busca e filtros */}
            <div className="search-bar" ref={searchBarRef}>
              {/* Campo de busca com select de tipo */}
              <div className="search-input-wrapper">
                {/* Select de tipo inline */}
                <div className="search-type-select">
                  <button
                    className="search-type-btn"
                    onClick={() => setTypeDropdownOpen((v) => !v)}
                  >
                    <Text variant="label-sm">{currentSearchType.label}</Text>
                    <Icon icon={CaretDown} size={14} weight="bold" />
                  </button>
                  {typeDropdownOpen && (
                    <ul className="search-type-dropdown">
                      {SEARCH_TYPE_OPTIONS.map((opt) => (
                        <li
                          key={opt.value}
                          className={`search-type-option${searchType === opt.value ? ' search-type-option--active' : ''}`}
                          onMouseDown={() => {
                            setSearchType(opt.value);
                            setTypeDropdownOpen(false);
                            setSearchQuery('');
                          }}
                        >
                          <Text variant="body-sm">{opt.label}</Text>
                        </li>
                      ))}
                    </ul>
                  )}
                </div>

                <div className="search-divider" />

                <Icon icon={MagnifyingGlass} size={16} weight="regular" className="search-icon" />
                <input
                  className="search-input-native"
                  placeholder={currentSearchType.placeholder}
                  value={searchQuery}
                  onChange={(e) => setSearchQuery(e.target.value)}
                  onKeyDown={handleKeyDown}
                />
              </div>

              {/* Botão Filtros + painel dropdown */}
              <div className="filtro-panel-anchor" ref={filtroPanelRef}>
                <button
                  className={`filtros-btn${filtroPanelOpen ? ' filtros-btn--active' : ''}`}
                  onClick={() => setFiltroPanelOpen((v) => !v)}
                >
                  <Icon icon={Funnel} size={16} weight="regular" />
                  Filtros
                  {filtrosAtivosCount > 0 && (
                    <span className="filtros-badge">{filtrosAtivosCount}</span>
                  )}
                </button>

                {filtroPanelOpen && (
                  <div className="filtro-panel">
                    <div className="filtro-panel-header">
                      <Text variant="label-base">Filtros</Text>
                      {filtrosAtivosCount > 0 && (
                        <button className="filtro-panel-limpar" onClick={handleLimparFiltros}>
                          Limpar
                        </button>
                      )}
                    </div>

                    {/* Data de Pagamento */}
                    <div className="filtro-item">
                      <button className="filtro-item-header" onClick={() => toggleFiltroItem('dataPagamento')}>
                        <Text variant="body-sm">Data de Pagamento</Text>
                        <Icon icon={expandedFiltro === 'dataPagamento' ? CaretUp : CaretDown} size={16} weight="regular" />
                      </button>
                      {expandedFiltro === 'dataPagamento' && (
                        <div className="filtro-item-body">
                          <input
                            className="date-input-native"
                            type="date"
                            value={dataPagamento}
                            onChange={(e) => setDataPagamento(e.target.value)}
                          />
                        </div>
                      )}
                    </div>

                    {/* Data de Vencimento */}
                    <div className="filtro-item">
                      <button className="filtro-item-header" onClick={() => toggleFiltroItem('dataVencimento')}>
                        <Text variant="body-sm">Data de Vencimento</Text>
                        <Icon icon={expandedFiltro === 'dataVencimento' ? CaretUp : CaretDown} size={16} weight="regular" />
                      </button>
                      {expandedFiltro === 'dataVencimento' && (
                        <div className="filtro-item-body">
                          <input
                            className="date-input-native"
                            type="date"
                            value={dataVencimento}
                            onChange={(e) => setDataVencimento(e.target.value)}
                          />
                        </div>
                      )}
                    </div>

                    {/* Status */}
                    <div className="filtro-item">
                      <button className="filtro-item-header" onClick={() => toggleFiltroItem('status')}>
                        <Text variant="body-sm">Status</Text>
                        <Icon icon={expandedFiltro === 'status' ? CaretUp : CaretDown} size={16} weight="regular" />
                      </button>
                      {expandedFiltro === 'status' && (
                        <div className="filtro-item-body">
                          <Select
                            placeholder="Todos os status"
                            options={STATUS_OPTIONS}
                            value={statusFilter}
                            onChange={setStatusFilter}
                            size="sm"
                          />
                        </div>
                      )}
                    </div>

                    {/* Valor da Compra */}
                    <div className="filtro-item">
                      <button className="filtro-item-header" onClick={() => toggleFiltroItem('valor')}>
                        <Text variant="body-sm">Valor da Compra</Text>
                        <Icon icon={expandedFiltro === 'valor' ? CaretUp : CaretDown} size={16} weight="regular" />
                      </button>
                      {expandedFiltro === 'valor' && (
                        <div className="filtro-item-body">
                          <Input
                            placeholder="Ex: 150,00"
                            value={valorCompra}
                            onChange={(e) => setValorCompra((e.target as HTMLInputElement).value)}
                          />
                        </div>
                      )}
                    </div>

                    {/* Método de Pagamento */}
                    <div className="filtro-item">
                      <button className="filtro-item-header" onClick={() => toggleFiltroItem('metodo')}>
                        <Text variant="body-sm">Método de Pagamento</Text>
                        <Icon icon={expandedFiltro === 'metodo' ? CaretUp : CaretDown} size={16} weight="regular" />
                      </button>
                      {expandedFiltro === 'metodo' && (
                        <div className="filtro-item-body">
                          <Select
                            placeholder="Todos os métodos"
                            options={METODO_OPTIONS}
                            value={metodoPagamento}
                            onChange={setMetodoPagamento}
                            size="sm"
                          />
                        </div>
                      )}
                    </div>

                    <div className="filtro-panel-footer">
                      <Button
                        variant="fill"
                        disabled={!algumFiltroPreenchido || searchState === 'loading'}
                        onClick={handleAplicarFiltros}
                      >
                        Aplicar filtros
                      </Button>
                    </div>
                  </div>
                )}
              </div>
            </div>

            {/* Tabela sempre visível */}
            <div className="content-table">
              {searchState === 'error' && (
                <div style={{ padding: '16px' }}>
                  <Alert
                    variant="error"
                    title="Não foi possível carregar as transações."
                    description="Tente novamente em instantes."
                    showCloseButton={false}
                  />
                </div>
              )}

              <div className="content-table-scroll">
                <Table<Transacao>
                  data={searchState === 'results' ? pagedTransacoes : []}
                  columns={COLUMNS}
                  rowKey={(r) => r.id}
                  size="sm"
                  loading={searchState === 'loading'}
                  emptyText={
                    searchState === 'initial'
                      ? 'Realize uma pesquisa e aplique os filtros para localizar a transação que você procura.'
                      : 'Nenhuma transação encontrada. Tente ajustar os filtros.'
                  }
                  onRowClick={searchState === 'results' ? (record) => navigate(`/portal-payfacs/transacoes/${record.id}`) : undefined}
                  pagination={
                    searchState === 'results'
                      ? {
                          currentPage,
                          totalPages,
                          totalItems: transacoes.length,
                          pageSize: PAGE_SIZE,
                          onPageChange: setCurrentPage,
                        }
                      : undefined
                  }
                />
              </div>
            </div>
          </div>
      </main>
    </PortalPayfacsLayout>
  );
}
